<ng-container *ngIf="render$ | async"></ng-container>

<csl-svg-workspace #svgWorkspace [p]="panel"></csl-svg-workspace>
